import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Input } from './Styles';
import { getFormattedDateTime } from '../../shared/utils/common';

export const TimeLeft = ({
  notStatusedCount,
  defaultSecPerUnit,
  label,
  auctionStart,
  totalUnitsRun,
}) => {
  const LOCAL_STORAGE_VARIABLE = 'avgTimePerUnit';

  const [avgTimePerUnit, setAvgTimePerUnit] = useState(
    parseFloat(window.localStorage.getItem(LOCAL_STORAGE_VARIABLE)) ||
      defaultSecPerUnit,
  );

  const secondsToDecimal = (time) => time / 60;
  const defaultSecAsDecimal = secondsToDecimal(defaultSecPerUnit);
  const getHours = (value) => Math.floor(value / 60);
  const getMinutes = (value) => Math.floor(value % 60);
  const getSeconds = (value) => Math.floor((value * 60) % 60);
  const getTotalMinutesAllUnits = (units, timePerUnit) => units * timePerUnit;

  const formatMinuteText = (value) => `${value} min`;
  const formatSecondText = (value) => `${value} sec`;
  const formatHourText = (value) => `${value} hour${value === 1 ? '' : 's'}`;
  const formatTimeDisplayText = (time) => `${time} @`;

  const getTimeLeft = (items, timePerUnit = defaultSecAsDecimal) => {
    const timeInMinutes = getTotalMinutesAllUnits(items, timePerUnit);
    const hours = getHours(timeInMinutes);
    const minutes = getMinutes(timeInMinutes);
    if (hours === 0) return formatMinuteText(minutes);
    return `${formatHourText(hours)} ${formatMinuteText(minutes)}`;
  };

  const getRunningAverageTimePerUnit = (timeDiffInMinutes, totalUnitsRun) => {
    const timePerUnitRaw = timeDiffInMinutes / totalUnitsRun;
    const hours = getHours(timePerUnitRaw);
    const minutes = getMinutes(timePerUnitRaw);
    const seconds = getSeconds(timePerUnitRaw);
    if (hours === 0 && minutes === 0) return formatSecondText(seconds);
    if (hours === 0)
      return `${formatMinuteText(minutes)} ${formatSecondText(seconds)}`;
    return `${formatHourText(hours)} ${formatMinuteText(
      minutes,
    )} ${formatSecondText(seconds)}`;
  };

  const getTimeDiff = (startTime) => {
    const dtCurrent = new Date().getTime();
    const dtStart = new Date(startTime).getTime();
    const diff = (dtStart - dtCurrent) / 1000 / 60;
    const timeDiffInMinutes = Math.abs(Math.round(diff));
    const averageTimePerUnit = getRunningAverageTimePerUnit(
      timeDiffInMinutes,
      totalUnitsRun,
    );
    return `AVG TIME/UNIT SINCE AUCTION START: ${averageTimePerUnit}`;
  };

  const laneTimeLeft = getTimeLeft(
    notStatusedCount,
    secondsToDecimal(avgTimePerUnit),
  );
  const timeDisplayText = formatTimeDisplayText(laneTimeLeft, avgTimePerUnit);

  const onChangeAvgTime = (e) => setAvgTimePerUnit(e.currentTarget.value);

  useEffect(() => {
    window.localStorage.setItem(LOCAL_STORAGE_VARIABLE, avgTimePerUnit);
  }, [avgTimePerUnit, totalUnitsRun]);

  return (
    <Container>
      <span><button onClick={() => window.localStorage.setItem('startTimeInSanDiego', getFormattedDateTime(new Date()))}>{label}</button></span>
      <span title={getTimeDiff(auctionStart)}>
        {timeDisplayText}
        <Input value={avgTimePerUnit} onChange={onChangeAvgTime} />
        sec/unit
      </span>
    </Container>
  );
};

TimeLeft.propTypes = {
  notStatusedCount: PropTypes.number,
  defaultSecPerUnit: PropTypes.number,
  label: PropTypes.string,
};

TimeLeft.defaultProps = {
  notStatusedCount: 0,
  defaultSecPerUnit: 60,
  label: 'Estimated Time:',
};

export default TimeLeft;
